import { render, staticRenderFns } from "./SurveysGrid.vue?vue&type=template&id=12f3604d&scoped=true&"
import script from "./SurveysGrid.vue?vue&type=script&lang=js&"
export * from "./SurveysGrid.vue?vue&type=script&lang=js&"
import style0 from "./SurveysGrid.vue?vue&type=style&index=0&id=12f3604d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3604d",
  null
  
)

export default component.exports